/** Plan types for YogaKai members — catalog access + Teach builder. */

export const PLAN_TYPES = [
  {
    id: 'karma',
    label: 'Karma Yogi',
    priceLabel: 'Free',
    blurb:
      'Beginner Hatha pack with the timer practice player — on-screen cues and a breathing guide.',
    features: [
      '3 beginner Hatha classes',
      'Timer practice player',
      'On-screen cues + breathing guide',
      'Pose dictionary',
    ],
  },
  {
    id: 'guided',
    label: 'Guided Yogi',
    priceLabel: '$12 / mo',
    blurb:
      'Full class library with timed pose sequences, cues, and breathing — voice guidance coming later.',
    features: [
      'Full class library (17+ samples)',
      'Timer practice player',
      'On-screen cues + breathing guide',
      'Pose dictionary',
    ],
  },
  {
    id: 'teacher',
    label: 'Yoga Teacher',
    priceLabel: '$28 / mo',
    blurb:
      'Everything in Guided, plus a sequence builder to create and edit classes for your students.',
    features: [
      'Full class library',
      'Sequence builder (Teach)',
      'Tips & modifications in the player',
      'Pose dictionary + pose picker',
    ],
  },
];

export const PLAN_IDS = PLAN_TYPES.map((p) => p.id);

export function planLabel(planType) {
  return PLAN_TYPES.find((p) => p.id === planType)?.label || planType || '—';
}

export function isValidPlanType(planType) {
  return PLAN_IDS.includes(planType);
}

/** Karma only sees the marked beginner Hatha pack; Guided + Teacher see everything. */
export function lessonVisibleForPlan(lesson, planType) {
  if (planType === 'karma') return !!lesson?.karmaPack;
  return true;
}

/** Teacher plan sees tip/mod in the player; all plans use practitioner cues on-screen. */
export function usesTeacherVoice(planType) {
  return planType === 'teacher';
}

export function cuesForPlan(lesson, planType) {
  if (usesTeacherVoice(planType)) {
    return lesson?.cuesTeacher || lesson?.cues || '';
  }
  return lesson?.cues || '';
}

/** Teachers author and manage lessons; other plans practice from the catalog. */
export function canManageLessons(planType) {
  return planType === 'teacher';
}
